export const projectRequests = window.config.projectRequestsRoute;
export const requestGroupReview = `${projectRequests}/review`;
